<p>{{'account.go_buy_licence_passive_body' | translate}}</p>
<a mat-raised-button [href]="'navigation.external-target-link-menu-url' | translate" class="mat-accent">
    {{ 'account.go_buy_licence_passive_link' | translate }}
</a>
